export function getMaxNo(array) {
  const maxNo =
    array.length === 0
      ? { No: 0 }
      : array.reduce((maxObj, currentObj) => {
          return currentObj.No > maxObj.No ? currentObj : maxObj;
        });
  return maxNo.No + 1;
}
